import React from 'react'
import './BadgingUsageChart.scss'
import getBadgingUsageMetrics from './getBadgingUsageMetrics';
import formatNumberWithCommas from '../../util/formatNumberWithCommas'
import { useTranslation } from 'react-i18next';
import { getDateLabelsForUsageWindow } from '../../blocks/Select/UsageWindow';

export default function BadgingUsageChart(props) {
  const {usageWindow, reportData} = props;
  const {value} = usageWindow;
  const isSchoolYearUsageWindow = value === "school_year"

  const {t, i18n} = useTranslation("badging_report")

  // hide usage chart if usage window is school year
  if (isSchoolYearUsageWindow || !reportData) return null;

  const metrics = getBadgingUsageMetrics(reportData, usageWindow);
  const {labelStart, labelEnd} = getDateLabelsForUsageWindow(usageWindow, i18n);

  return (
    <div className='badging-usage-chart-container'>
      <div className='badging-usage-chart-header'>
        <div className='badging-usage-chart-title'>{t("My class usage")}</div>
        <div className='badging-usage-chart-description'>{t("Showing usage data")} {t("for_usage_week", {labelStart, labelEnd})}</div>
      </div>
      <div className='badging-usage-chart'>
        <div className='badging-usage-chart-bar'>{formatNumberWithCommas(metrics.badgeCount)} {t("badges")}</div>
        <div className='badging-usage-chart-bar'>{formatNumberWithCommas(metrics.activityCount)} {t("stories")}</div>
        <div className='badging-usage-chart-bar'>{formatNumberWithCommas(metrics.sessionTime)} {t("minutes")}</div>
      </div>
    </div>
  )
}
